import '../App.css';

function Socials() {
    const openSocials = (site: string) => {
        window.open(site === 'li'? "https://uk.linkedin.com/company/labourinthecity" : 'https://x.com/labourinthecity', "_blank")
    };

    return (
        <div className="socials-container">
            <p className="find-us-on">Find us on</p>
            <div className="socials">
                <button className='twitter-button' onClick={() => openSocials('tw')}><img alt="" src={require('../assets/x.png')} className='twitter-logo'></img></button>
                <button className='twitter-button' onClick={() => openSocials('li')}><img alt="" src={require('../assets/linkedin.png')} className='twitter-logo'></img></button>
            </div>
        </div>
    );
}

export default Socials;
